export const GET_ALL_ROOMS = "GET_ALL_ROOMS";
export const GET_ROOM_INFO = "GET_ROOM_INFO";
export const GET_USER_IN_ROOM_INFO = "GET_USER_IN_ROOM_INFO";
export const CLEAR_ROOMS = "CLEAR_ROOMS";